module.exports = __webpack_public_path__ + "static/11-min-67961147ba7fabe81f96efbc31b6517d.jpg";